import locations from "./locations"

const institutes_data = [
    {
        "name": "ITMP",
        "allowFlexTimeAccountsDefault" : true,
        'allowAdditionalCompensationForClosingDays': true,
        'maxFlexTimeCredit': "1.06:00:00",
        'maxFlexTimeDeficit': "-20:00:00",
    },
]

const institutes = institutes_data.map(i => {
    return {
        ...i,
        locations: locations,
    }
})

export default institutes
